import React, { memo } from 'react';
import { useLangFile } from 'js/context/LanguageContext';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';

interface BulkPrescriptionApplyIntervalsButtonProps {
  onClick: () => void;
}

const BulkPrescriptionApplyIntervalsButton: React.FC<BulkPrescriptionApplyIntervalsButtonProps> = ({
  onClick,
}) => {
  const LangFile = useLangFile();

  return (
    <Box
      sx={{
        ml: 1,
      }}
    >
      <Button
        data-testid="bulk-apply-intervals"
        variant={'contained'}
        color={'primary'}
        onClick={onClick}
      >
        <CheckIcon />
        <Box
          sx={{
            ml: 1,
          }}
        >
          {LangFile.BulkPrescriptionApplyIntervalsButton.label}
        </Box>
      </Button>
    </Box>
  );
};

export default memo(BulkPrescriptionApplyIntervalsButton);
